<template>
    <form-section
        id="closing"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <closing-scheduled-date
            v-model="scheduled_closing_date"
            :read_only="read_only"
        />

        <titleease-order-tile
            v-if="titleease_enabled"
            :property="property"
            :order_title_route="order_title_route"
            :order_status_route="order_status_route"
            :contract_documents_route="contract_documents_route"
            :read_only="read_only"
        />

        <closing-disclosure
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-signed
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-sent
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-confirmed
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-title-company
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-contact
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-wire-instructions
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-wired-funds
            :closing="property.closing"
            :read_only="read_only"
        />
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import ClosingScheduledDate from './closing-scheduled-date.vue';
import ClosingDisclosure from './closing-disclosure.vue';
import ClosingSigned from './closing-signed.vue';
import ClosingSent from './closing-sent.vue';
import ClosingConfirmed from './closing-confirmed.vue';
import ClosingTitleCompany from './closing-title-company.vue';
import ClosingWireInstructions from './closing-wire-instructions.vue';
import ClosingWiredFunds from './closing-wired-funds.vue';
import ClosingContact from './closing-contact.vue';
import TitleeaseOrderTile from '../../referrals/titleease/titleease-order-tile.vue';

export default {
    components: {
        FormSection,
        ClosingScheduledDate,
        ClosingDisclosure,
        ClosingSigned,
        ClosingSent,
        ClosingConfirmed,
        ClosingTitleCompany,
        ClosingWireInstructions,
        ClosingWiredFunds,
        ClosingContact,
        TitleeaseOrderTile,
    },

    props: {
        property: {},
        url: {},
        read_only: { default: false },
        available_contacts: { default: () => [] },
        order_title_route: {},
        order_status_route: {},
        contract_documents_route: {},
        titleease_enabled: { default: false },
    },

    data() {
        return {
            scheduled_closing_date: this.property.closing.scheduled_closing_date,
        }
    },
}
</script>
